export default "__VITE_ASSET__Q_UW0Fqa__"